export enum Section {
  companies,
  employees,
  interns,
  workStudy,
  students,
  selfEmployed,
}
